// Pricing configuration for GhostHub OasiS
export const pricing = {
  ghosthub: {
    price: 199,
    version: "3.0",
    shipping: "shipping",
    currency: "$"
  },
  competitors: {
    plex: {
      lifetime: 249.99,
      monthly: 6.99
    },
    jellyfin: {
      price: 0
    }
  }
};

export default pricing;
